import React, { useEffect, useState } from "react";
import { ArrowUpRight, RotateCcw } from "lucide-react";
import { euro, practiceApi } from "../../lib/practiceApi";

export const ECONOMICS_METRICS = [
  ["total_fees", "Totale compensi"], ["outstanding", "Da incassare"], ["collected", "Incassato"],
  ["invoiced", "Fatturato"], ["to_invoice", "Da fatturare"],
];
export const DEFAULT_ECONOMICS_METRICS = ECONOMICS_METRICS.map(([key]) => key);

export const EconomicsMetricsPicker = ({ selected, onChange }) => <fieldset className="cr-economy-picker" data-testid="cr-economy-picker">
  <legend>Voci del riepilogo Economia</legend><div>{ECONOMICS_METRICS.map(([key, label]) => <label key={key}><input type="checkbox" data-testid={`cr-tune-economics-${key}`} checked={selected.includes(key)} onChange={event => onChange(ECONOMICS_METRICS.map(([id]) => id).filter(id => id === key ? event.target.checked : selected.includes(id)))} />{label}</label>)}</div>
</fieldset>;

export const EconomicsSummary = ({ selected, onOpen }) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    let alive = true, sequence = 0;
    const load = async () => {
      const current = ++sequence;
      try { const result = await practiceApi("/finance/dashboard-summary"); if (alive && current === sequence) { setData(result); setError(""); } }
      catch (err) { if (alive && current === sequence) { setError(err.message); setData(null); } }
    };
    load(); window.addEventListener("focus", load);
    return () => { alive = false; window.removeEventListener("focus", load); };
  }, [retry]);
  if (!selected.length) return null;
  return <section className="cr-economy-summary" data-testid="cr-economics">
    <header><div><h2>Riepilogo Economia</h2><span data-testid="cr-economics-period">Tutti gli anni</span></div><button className="ghost" data-testid="cr-economics-open" onClick={onOpen}>Apri economia <ArrowUpRight size={14} /></button></header>
    {error ? <div className="error" role="alert" data-testid="cr-economics-error">{error}<button type="button" className="ghost" data-testid="cr-economics-retry" onClick={() => setRetry(v => v + 1)}><RotateCcw size={14} />Riprova</button></div>
      : <div className="cr-economy-values">{ECONOMICS_METRICS.filter(([key]) => selected.includes(key)).map(([key, label]) => <button key={key} className={`cr-economy-value ${key}`} data-testid={`cr-economics-item-${key}`} onClick={onOpen}>
          <span>{label}</span><strong data-testid={`cr-economics-value-${key}`}>{data ? euro(data[key]) : "—"}</strong><small>{!data ? "Caricamento…" : key === "to_invoice" ? "Quote maturate" : key === "invoiced" ? "Fatture registrate" : key === "collected" ? "Acconti e pagamenti" : "Totale complessivo"}</small>
        </button>)}</div>}
  </section>;
};